import React from 'react';
import { Typography, Divider, Space, Image } from 'antd';
import { InfoCircleOutlined, EditOutlined } from '@ant-design/icons';

const { Title, Paragraph, Text } = Typography;

const HelpMokykluPagrindineInformacija = () => (
    <div className="help-content">
        <Space direction="vertical" size="middle" style={{ width: '100%' }}>
            <div>
                <Title level={2} style={{ marginBottom: 16 }}>
                    Mokyklos darbalaukis
                </Title>
                <Paragraph style={{ fontSize: 16, lineHeight: 1.8 }}>
                    Šiame lange pateikiama pagrindinė jūsų mokyklos informacija, kuri naudojama visoje VKSIS sistemoje.
                </Paragraph>
            </div>

            <div className="help-screenshot-placeholder">
                <Image
                    src="https://api.vksis.lt/img/help/mokyklu_pag_info.webp"
                    alt="Mokyklos pagrindinės informacijos lango screenshot"
                    preview={false}
                    style={{ width: '100%', borderRadius: 8, border: '1px solid #e8e8e8' }} />
            </div>

            <Divider />

            <div>
                <Title level={3} style={{ marginBottom: 12 }}>
                    <InfoCircleOutlined style={{ marginRight: 8, color: '#fdab01' }} />
                    Langas ir jo struktūra
                </Title>
                <Paragraph style={{ fontSize: 15, lineHeight: 1.8, marginBottom: 16 }}>
                    <Text strong>Kairėje pusėje</Text> matomas VKSIS sistemos navigacijos meniu su geltonu logotipo header&apos;iu. Meniu leidžia pasiekti pagrindinius sistemos modulius, tokius kaip <Text strong>Darbalaukis</Text> ir <Text strong>Apklausos</Text>.
                </Paragraph>
                <Paragraph style={{ fontSize: 15, lineHeight: 1.8, marginBottom: 16 }}>
                    <Text strong>Viršuje dešinėje</Text> pusėje matote vartotojo profilio sekciją su mokyklos pavadinimu ir tipo informacija, taip pat redagavimo mygtuką su pieštuko ikona.
                </Paragraph>
                <Paragraph style={{ fontSize: 15, lineHeight: 1.8, marginBottom: 16 }}>
                    <Text strong>Pagrindinėje turinio srityje</Text> matote horizontalius tab&apos;us, kurie leidžia naršyti tarp skirtingų mokyklos skyrių:
                </Paragraph>
                <ul style={{ fontSize: 15, lineHeight: 1.8, marginTop: 12, marginBottom: 16 }}>
                    <li><Text strong>Pagrindinė informacija</Text> (aktyvus tab)</li>
                    <li>Rodiklių duomenenys</li>
                    <li>Klasės</li>
                    <li>Egzaminai</li>
                    <li>Vartotojai</li>
                    <li>Kontaktai</li>
                    <li>BVM Apklausos</li>
                    <li>Projektai</li>
                </ul>
                <Paragraph style={{ fontSize: 15, lineHeight: 1.8, marginBottom: 16 }}>
                    <Text strong>&ldquo;Mokyklos informacija&rdquo; sekcijoje</Text> pateikiama pagrindinė mokyklos informacija dviem stulpeliais:
                </Paragraph>
                <ul style={{ fontSize: 15, lineHeight: 1.8, marginTop: 12, marginBottom: 16 }}>
                    <li><Text strong>Pavadinimas</Text> – mokyklos pilnas pavadinimas</li>
                    <li><Text strong>Adresas</Text> – pilnas mokyklos adresas su pašto kodu</li>
                    <li><Text strong>Telefonas</Text> – kontaktinis telefono numeris</li>
                    <li><Text strong>Tipas</Text> – mokyklos tipas (pvz., gimnazija, progimnazija ir kt.)</li>
                </ul>
                <Paragraph style={{ fontSize: 15, lineHeight: 1.8, marginBottom: 16 }}>
                    <Text strong>Žemėlapio sekcijoje</Text> integruotas Google Maps žemėlapis, kuriame geltona-oranžinė žymė rodo mokyklos tikslų adresą. Žemėlapis leidžia vizualiai patikrinti, ar mokyklos adresas yra nurodytas teisingai, ir pamatyti aplinkinę infrastruktūrą.
                </Paragraph>
            </div>

            <Divider />

            <div>
                <Title level={3} style={{ marginBottom: 12 }}>
                    <EditOutlined style={{ marginRight: 8, color: '#fdab01' }} />
                    Duomenų redagavimas
                </Title>
                <Paragraph style={{ fontSize: 15, lineHeight: 1.8 }}>
                    Jeigu pasikeitė mokyklos kontaktiniai duomenys, adresas ar kiti pagrindiniai duomenys, spauskite mygtuką <Text strong>&ldquo;Redaguoti mokyklos informaciją&rdquo;</Text> ir atnaujinkite informaciją.
                </Paragraph>
                <Paragraph style={{ fontSize: 15, lineHeight: 1.8, marginTop: 12 }}>
                    Atnaujinti duomenys bus matomi tiek jūsų mokyklai, tiek Švietimo skyriui.
                </Paragraph>
                <Paragraph style={{ fontSize: 15, lineHeight: 1.8, marginTop: 12, color: '#666' }}>
                    <Text italic>Išsamesnę informaciją apie redagavimo procesą rasite skyriuje &ldquo;Mokyklos informacijos redagavimas&rdquo;.</Text>
                </Paragraph>
            </div>
        </Space>
    </div>
);

export default HelpMokykluPagrindineInformacija;
